import { render, staticRenderFns } from "./CaseTypeCard.vue?vue&type=template&id=d5c95598&scoped=true&"
import script from "./CaseTypeCard.vue?vue&type=script&lang=ts&"
export * from "./CaseTypeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c95598",
  null
  
)

export default component.exports